import {EnvironmentProviders,PLATFORM_ID,effect,inject,makeEnvironmentProviders,provideAppInitializer} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {ConsentService} from './consent.service';
import {MetaPixelService} from '../facebook/meta-pixel.service';
import {XPixelService} from '../x/x-pixel.service';

export function provideConsentTracking():EnvironmentProviders{
	return makeEnvironmentProviders([
		provideAppInitializer(()=>{
			if(!isPlatformBrowser(inject(PLATFORM_ID))) return;
			const consent=inject(ConsentService);
			const metaPixel=inject(MetaPixelService);
			const xPixel=inject(XPixelService);
			effect(()=>{
				if(!consent.marketing()) return;
				void metaPixel.start();
				void xPixel.start();
			});
		})
	]);
}
